import './ServiceB.scss';

export default function ServiceB() {
	return (
		<section>
			<div className='container'>
				<div className='row'>
					<div className='col-12 col-md-6 col-lg-4'>
						<div className='card h-80 border-primary-color shadow-lg p-3 mb-5 rounded'>
							<div className='text-center pt-2'>
								<i className='bi bi-person-check style-icon-service'></i>
							</div>
							<div className='card-body'>
								<h5 className='card-title text-center h2 fw-bold'>Flota Especializada</h5>
								<p className='card-text text-center px-4 text-muted'>
									Unidades en excelente estado, todas debidamente identificadas con
									branding empresarial y equipadas con equipos de rastreo satelital.
								</p>
							</div>
						</div>
					</div>
					<div className='col-12 col-md-6 col-lg-4'>
						<div className='card h-80 border-primary-color shadow-lg p-3 mb-5 rounded bg-primary-color'>
							<div className='text-center pt-2'>
								<i className='bi bi-geo-fill style-icon-service-hover'></i>
							</div>
							<div className='card-body'>
								<h5 className='card-title text-center h2 fw-bold text-white'>
									Monitoreo Total
								</h5>
								<p className='card-text text-center px-4 text-white'>
									Comunicación permanente con los operadores vía celular, eficiente
									capacidad de respuesta ante siniestros e imprevistos, trazabilidad en
									tiempo real y tableros de seguimiento con tecnología propia STRATEGOS
								</p>
							</div>
						</div>
					</div>
					<div className='col-12 col-md-6 col-lg-4'>
						<div className='card h-80 border-primary-color shadow-lg p-3 mb-5 rounded'>
							<div className='text-center pt-2'>
								<i className='bi bi-person-badge style-icon-service'></i>
							</div>
							<div className='card-body'>
								<h5 className='card-title text-center h2 fw-bold'>Capital Humano</h5>
								<p className='card-text text-center px-4 text-muted'>
									Nuestro personal esta preparado para operar con calidad. Operadores
									certificados con Rcontrol y Black Trust Pruebas Antidoping Procesos
									robusto de selección y contratación Todos debidamente identificados y
									uniformados
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
